export const POSITION_FILTER_ORDER = ["QB", "RB", "TE", "WR", "K", "IDP"] as const;

const IDP_POSITIONS = new Set(["D", "CB", "DB", "DE", "DI", "DL", "DT", "ED", "EDGE", "ILB", "LB", "OLB", "S"]);

export function isIdpPosition(position: string): boolean {
  const normalized = position.toLocaleUpperCase("en-US");
  return IDP_POSITIONS.has(normalized);
}

export function matchesPositionFilter(positions: readonly string[], filter: string): boolean {
  if (filter === "ALL") return true;
  if (filter === "IDP") return positions.some(isIdpPosition);
  return positions.includes(filter);
}
